import { ApiClient } from "@skoda/k2tools-app-services/lib";
import { OwnersManualsSettings } from "../models/appSettings";

export class SettingsService {
	private _apiClient: ApiClient;
	private _api: string;
	private _data: OwnersManualsSettings;

	constructor(apiClient: ApiClient, api: string) {
		this._apiClient = apiClient;
		this._api = api;
	}

	public get data() {
		return this.getWithNullcheck(this._data);
	}

	public load = () =>
		this._apiClient.callApi<OwnersManualsSettings>('get', this._api)
			.then(this.setData)

	private setData = (data: OwnersManualsSettings) =>
		this._data = data;

	private getWithNullcheck = <T>(property: T) => {
		if (!property)
			throw new Error('Owners Manuals settings not loaded.');
		return property;
	};
}